import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"แปลสัญญากฎหมาย ไทย-อังกฤษ — ISO 17100 + Terminology Lock","metaTitle":"แปลสัญญา — Legal Contract Translation ตาม ISO 17100 | NYC","metaDesc":"แปลสัญญา MSA, SPA, JV, Employment, NDA, License 2 ภาษา ISO 17100 + 4-eyes review + Legal Reviewer /คำ — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี"},"en":{"h1":"Legal Contract Translation — ISO 17100 + Term Lock","metaTitle":"Thai-English Legal Contract Translation — ISO 17100 | NYC","metaDesc":"MSA, SPA, JV, employment, NDA, licence — ISO 17100 workflow, 4-eyes review, legal reviewer. /word. Certif — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/en/translate/legal-contract")({
  head: () => {
    const url = `${SEO_SITE}/en/translate/legal-contract`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/translate/legal-contract", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/translate/legal-contract", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/translate/legal-contract", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/translate/legal-contract", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/translate/legal-contract", "/en/translate/legal-contract")],
    };
  },
  component: () => <SubServicePage slug="translate/legal-contract" locale="en" />,
});
